import React, { useState, useContext } from 'react';
import {
  DataGridGroup,
  Button,
  useResponsiveParams,
  Text,
} from 'quanta-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDownload,
  faEnvelope,
  faSms,
  faSpinner,
  faUpload,
} from '@fortawesome/free-solid-svg-icons';
import {
  SEARCH_CUSTOMER_BY_NUMBER,
  VIEW_POLICY_FIRE,
  SEND_POLICY_EMAIL_FIRE,
  SEND_POLICY_SMS_FIRE,
  DOWNLOAD_FIRE_POLICY_PDF,
  INTERMEDIARY_LIST,
  VIEW_PROPOSAL_FIRESF,
  SEND_POLICY_SMS_ALERT,
  SEND_POLICY_EMAIL_ALERT,
  DOWNLOAD_POLICY_PDF
} from '../queries';
import { useHistory } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { Loading ,Error } from 'quanta-flows/modules/layout';
import { CurrencyFormater } from 'quanta-flows';
import { useMutationQuery } from 'quanta-flows';
import { QuantaConfigContext } from 'quanta-flows';
//import {TransactionComponent} from 'quanta-flows/modules/security';
import { ModalViewBreakupFire } from 'quanta-flows/modules/common/viewBreakUp';
import {ModalSendSms,} from 'quanta-flows/modules/common/modals';
import { ModalSendEmail} from 'quanta-flows/modules/common/modals';

export default function PolicySummaryPanelFire({
  proposal_no,
  policy_no,
  customer_id,
  lobProductList,
}) {
  const { branding } = useContext(QuantaConfigContext);
  const [showViewBreakup, setShowViewBreakup] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [showEmail, setShowEmail] = useState(false);
  const [showSms, setShowSms] = useState(false);
  const mutateQuery = useMutationQuery();
  const history = useHistory();
  const repeatForMobile = 1,
    repeatForDesktop = 2;

  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });

  let { loading, error, data } = useQuery(VIEW_PROPOSAL_FIRESF, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        proposalNumber: proposal_no,
        customerID: customer_id,
        productCode: '1132',
      },
    },
  });

  let {
    loading: loadingCustomer,
    error: errorCustomer,
    data: customerData,
  } = useQuery(SEARCH_CUSTOMER_BY_NUMBER, {
    variables: {
      input: {
        customer_number: customer_id,
      },
    },
    fetchPolicy: 'cache-first',
  });

  const {
    loading: loadingMyIntermediaries,
    error: errorMyIntermediaries,
    data: dataMyIntermediaries,
  } = useQuery(INTERMEDIARY_LIST);

  if (loading || loadingCustomer || loadingMyIntermediaries) {
    return <Loading />;
  }

  if (error || errorCustomer || errorMyIntermediaries) {
    return <Error {...{ error }} />;
  }
  let { viewProposalSF } = data;
  let { customer } = customerData;
  let { myIntermediaries } = dataMyIntermediaries;

  const reformData = (val, returnType) => {
    return val && val.toString().trim() !== '' ? val : returnType;
  };

  const product_info = (
    <div className="">
      <Text type="title" severity="info">
        {reformData(viewProposalSF?.product?.productName, null)}
      </Text>
    </div>
  );
  const getPayLoadsms = (mobile, alternateMobileNos) => {
    return {
      input: {
        proposerDetails: {
          id: customerData?.customer?.cust_number,
          customerType: customerData?.customer?.cust_type?.code,
          title: customerData?.customer?.indv_detail?.title?.code,
          firstName: customerData?.customer?.indv_detail?.first_name,
          middleName: customerData?.customer?.indv_detail?.middle_name,
          lastName: customerData?.customer?.indv_detail?.surname,
          fullName: customerData?.customer?.indv_detail?.full_name,
          gender: customerData?.customer?.indv_detail?.gender?.code,
          proposerDOB: customerData?.customer?.indv_detail?.date_of_birth,
          orgName: customerData?.customer?.org_detail?.org_name,
          orgType: customerData?.customer?.org_detail?.org_type?.code,
          contactName: customerData?.customer?.org_detail?.contact_name,
          mobileNo: customerData?.customer?.contact?.mobile,
          emailID: customerData?.customer?.contact?.email,
        },
        insuredDetails: [],
        proposalPaymentType: viewProposalSF?.Proposal_Payment_Type ,
        quotationType: viewProposalSF?.TypeofBusiness,
        intermediary: {
          intermediaryCode: viewProposalSF?.intermediaryDetails?.code,
          locationCode: viewProposalSF?.intermediaryDetails?.location,
          fieldUserCode: '',
        },
        startDate: viewProposalSF?.startDate,
        endDate: viewProposalSF?.endDate,
        zone: viewProposalSF?.zone,
        coverType: viewProposalSF?.ThirdGrid_Details?.Type_Of_Cover,
        plan: {
          name: viewProposalSF?.ThirdGrid_Details?.Type_Of_Cover,
          code: '',
          premium: {stampDuty: 0.00},
        },
        sumInsured: viewProposalSF?.ThirdGrid_Details?.TotalBuilding_Sum_Insured,
        tenure: '1',
        isHealthDeclarationSelected:
          true,
        quoteNumber: viewProposalSF?.proposalNumber,
        productCode: '1132',
      },
      policyNumber: viewProposalSF?.policyNumber,
      proposalNumber: viewProposalSF?.proposalNumber,
      mobile,
      alternateMobileNos,
    };
  };
  const getPayLoademail = (email, ccEmailIds) => {
    return {
      input: {
        proposerDetails: {
          id: customerData?.customer?.cust_number,
          customerType: customerData?.customer?.cust_type?.code,
          title: customerData?.customer?.indv_detail?.title?.code,
          firstName: customerData?.customer?.indv_detail?.first_name,
          middleName: customerData?.customer?.indv_detail?.middle_name,
          lastName: customerData?.customer?.indv_detail?.surname,
          fullName: customerData?.customer?.indv_detail?.full_name,
          gender: customerData?.customer?.indv_detail?.gender?.code,
          proposerDOB: customerData?.customer?.indv_detail?.date_of_birth,
          orgName: customerData?.customer?.org_detail?.org_name,
          orgType: customerData?.customer?.org_detail?.org_type?.code,
          contactName: customerData?.customer?.org_detail?.contact_name,
          mobileNo: customerData?.customer?.contact?.mobile,
          emailID: customerData?.customer?.contact?.email,
        },
        insuredDetails: [],
        proposalPaymentType: viewProposalSF?.Proposal_Payment_Type ,
        quotationType: viewProposalSF?.TypeofBusiness,
        intermediary: {
          intermediaryCode: viewProposalSF?.intermediaryDetails?.code,
          locationCode: viewProposalSF?.intermediaryDetails?.location,
          fieldUserCode: '',
        },
        startDate: viewProposalSF?.startDate,
        endDate: viewProposalSF?.endDate,
        zone: viewProposalSF?.zone,
        coverType: viewProposalSF?.ThirdGrid_Details?.Type_Of_Cover,
        plan: {
          name: viewProposalSF?.ThirdGrid_Details?.Type_Of_Cover,
          code: '',
          premium: {totalPremium: viewProposalSF?.finalisedPremium?.locTotalPremium},
        },
        sumInsured: viewProposalSF?.ThirdGrid_Details?.TotalBuilding_Sum_Insured,
        tenure: '1',
        isHealthDeclarationSelected:
          true,
        quoteNumber: viewProposalSF?.proposalNumber,
        productCode: '1132',
      },
      policyNumber: viewProposalSF?.policyNumber,
      proposalNumber: viewProposalSF?.proposalNumber,
      email,
      ccEmailIds,
    };
  };
  const sendPdfData = (viewProposalSF,
    customer,
    policy_no) => {
    return {
      input: {
        proposerDetails: {
          id: customerData?.customer?.cust_number,
          customerType: customerData?.customer?.cust_type?.code,
          title: customerData?.customer?.indv_detail?.title?.code,
          firstName: customerData?.customer?.indv_detail?.first_name,
          middleName: customerData?.customer?.indv_detail?.middle_name,
          lastName: customerData?.customer?.indv_detail?.surname,
          fullName: customerData?.customer?.indv_detail?.full_name,
          gender: customerData?.customer?.indv_detail?.gender?.code,
          proposerDOB: customerData?.customer?.indv_detail?.date_of_birth,
          orgName: customerData?.customer?.org_detail?.org_name,
          orgType: customerData?.customer?.org_detail?.org_type?.code,
          contactName: customerData?.customer?.org_detail?.contact_name,
          mobileNo: customerData?.customer?.contact?.mobile,
          emailID: customerData?.customer?.contact?.email,
        },
        insuredDetails: [],
        proposalPaymentType: viewProposalSF?.Proposal_Payment_Type ,
        quotationType: viewProposalSF?.TypeofBusiness,
        intermediary: {
          intermediaryCode: viewProposalSF?.intermediaryDetails?.code,
          locationCode: viewProposalSF?.intermediaryDetails?.location,
          fieldUserCode: '',
        },
        startDate: viewProposalSF?.startDate,
        endDate: viewProposalSF?.endDate,
        zone: viewProposalSF?.zone,
        coverType: viewProposalSF?.ThirdGrid_Details?.Type_Of_Cover,
        plan: {
          name: viewProposalSF?.ThirdGrid_Details?.Type_Of_Cover,
          code: '',
          premium: {totalPremium: viewProposalSF?.finalisedPremium?.locTotalPremium},
        },
        sumInsured: viewProposalSF?.ThirdGrid_Details?.TotalBuilding_Sum_Insured,
        tenure: '1',
        isHealthDeclarationSelected:
          true,
        quoteNumber: viewProposalSF?.proposalNumber,
        productCode: '1132',
      },
    policyNumber: viewProposalSF?.policyNumber,
      proposalNumber: viewProposalSF?.proposalNumber,
    }
  };
  const getBase64VarForFire = (
    viewProposalSF,
    customer,
    policy_no,
  ) => {
    return {
      input: {
        intermediary: {
          intermediaryCode: viewProposalSF?.intermediaryDetails?.code
            ? `${viewProposalSF?.intermediaryDetails?.code}`
            : '',
          locationCode: viewProposalSF?.intermediaryDetails?.location
            ? `${viewProposalSF?.intermediaryDetails?.location}`
            : '',
          fieldUserCode: viewProposalSF?.intermediaryDetails
            ?.fieldUserCode
            ? `${viewProposalSF?.intermediaryDetails?.fieldUserCode}`
            : '',
        },

        lob: '11',
        product: viewProposalSF?.product?.productCode
          ? `${viewProposalSF?.product?.productCode}`
          : '',

        customer: {
          id: customer?.cust_number ? `${customer?.cust_number}` : '',
          customerType: customer?.cust_type?.code
            ? `${customer?.cust_type?.code}`
            : '',
          title: customer?.indv_detail?.title?.code
            ? `${customer?.indv_detail?.title?.code}`
            : '',
          gender: customer?.indv_detail?.gender?.code
            ? `${customer?.indv_detail?.gender?.code}`
            : '',
          firstName: customer?.indv_detail?.first_name
            ? `${customer?.indv_detail?.first_name}`
            : '',
          middleName: customer?.indv_detail?.middle_name
            ? `${customer?.indv_detail?.middle_name}`
            : '',
          lastName: customer?.indv_detail?.surname
            ? `${customer?.indv_detail?.surname}`
            : '',
          fullName: customer?.indv_detail?.full_name
            ? `${customer?.indv_detail?.full_name}`
            : '',
          maritalStatus: customer?.indv_detail?.marital_status?.code
            ? `${customer?.indv_detail?.marital_status?.code}`
            : '',
          occupation: customer?.indv_detail?.occupation?.code
            ? `${customer?.indv_detail?.occupation?.code}`
            : '',
          nationality: customer?.indv_detail?.nationality?.code
            ? `${customer?.indv_detail?.nationality?.code}`
            : '',
          proposerDOB: customer?.indv_detail?.date_of_birth
            ? `${customer?.indv_detail?.date_of_birth}`
            : '',
          panNumber: customer?.indv_detail?.pan_card_number
            ? `${customer?.indv_detail?.pan_card_number}`
            : customer?.org_detail?.pan_card_number     /*CR 498  */
            ? `${customer?.org_detail?.pan_card_number}`
            : '',
          idProofType: customer?.indv_detail?.id_proof_type?.code
            ? `${customer?.indv_detail?.id_proof_type?.code}`
            : '',
          idProofNumber: customer?.indv_detail?.id_proof_number
            ? `${customer?.indv_detail?.id_proof_number}`
            : '',
          permAddressLine1: customer?.permanent_address?.address_line1
            ? `${customer?.permanent_address?.address_line1}`
            : '',
          permAddressLine2: customer?.permanent_address?.address_line2
            ? `${customer?.permanent_address?.address_line2}`
            : '',
          permAddressLine3: customer?.permanent_address?.address_line3
            ? `${customer?.permanent_address?.address_line3}`
            : '',
          permLandmark: customer?.permanent_address?.land_mark
            ? `${customer?.permanent_address?.land_mark}`
            : '',
          permPincode: customer?.permanent_address?.pin_code
            ? `${customer?.permanent_address?.pin_code}`
            : '',
          permCityTownVillage: customer?.permanent_address?.city
            ? `${customer?.permanent_address?.city}`
            : '',
          permDistrict: customer?.permanent_address?.district
            ? `${customer?.permanent_address?.district}`
            : '',
          permState: customer?.permanent_address?.state
            ? `${customer?.permanent_address?.state}`
            : '',
          permCommAddressYN: customer?.comm_equal_perm ? true : false,
          commAddressLine1: customer?.communication_address
            ?.address_line1
            ? `${customer?.communication_address?.address_line1}`
            : '',
          commAddressLine2: customer?.communication_address
            ?.address_line2
            ? `${customer?.communication_address?.address_line2}`
            : '',
          commAddressLine3: customer?.communication_address
            ?.address_line3
            ? `${customer?.communication_address?.address_line3}`
            : '',
          commLandmark: customer?.communication_address.land_mark
            ? `${customer?.communication_address?.land_mark}`
            : '',
          commPincode: customer?.communication_address?.pin_code
            ? `${customer?.communication_address?.pin_code}`
            : '',
          commCityTownVillage: customer?.communication_address?.city
            ? `${customer?.communication_address?.city}`
            : '',
          commDistrict: customer?.communication_address?.district
            ? `${customer?.communication_address?.district}`
            : '',
          commState: customer?.communication_address?.state
            ? `${customer?.communication_address?.state}`
            : '',
          phoneNo: customer?.contact?.telephone
            ? `${customer?.contact?.telephone}`
            : '',
          mobileNo:
            customer?.contact?.mobile ||
            customer?.org_detail?.contact_mob
              ? `${
                  customer?.contact?.mobile ||
                  customer?.org_detail?.contact_mob
                }`
              : '',
          emailID:
            customer?.contact?.email ||
            customer?.org_detail?.contact_email
              ? `${
                  customer?.contact?.email ||
                  customer?.org_detail?.contact_email
                }`
              : '',
          faxNo: customer?.contact?.fax_number
            ? `${customer?.contact?.fax_number}`
            : '',
          altPhoneNo: customer?.contact?.alt_telephone
            ? `${customer?.contact?.alt_telephone}`
            : '',
          altMobileNo: customer?.contact?.alt_mobile
            ? `${customer?.contact?.alt_mobile}`
            : '',
          orgName: customer?.org_detail?.org_name
            ? `${customer?.org_detail?.org_name}`
            : '',
          orgType: customer?.org_detail?.org_type?.code
            ? `${customer?.org_detail?.org_type?.code}`
            : '',
          contactName: customer?.org_detail?.contact_name
            ? `${customer?.org_detail?.contact_name}`
            : '',
          regNumber: customer?.org_detail?.reg_number
            ? `${customer?.org_detail?.reg_number}`
            : '',
          tanNumber: customer?.org_detail?.tan_number
            ? `${customer?.org_detail?.tan_number}`
            : '',
          gstNumber:
            customer?.org_detail?.gst_number ||
            customer?.indv_detail?.gst_number
              ? `${
                  customer?.org_detail?.gst_number ||
                  customer?.indv_detail?.gst_number
                }`
              : '',
          ifscCode: customer?.bank_detail?.ifsc_code
            ? `${customer?.bank_detail?.ifsc_code}`
            : '',
          bankName: customer?.bank_detail?.name
            ? `${customer?.bank_detail?.name}`
            : '',
          branchName: customer?.bank_detail?.branch_name
            ? `${customer?.bank_detail?.branch_name}`
            : '',
          bankAcno: customer?.bank_detail?.acc_number
            ? `${customer?.bank_detail?.acc_number}`
            : '',
          accountHolderName: customer?.bank_detail?.acc_holder
            ? `${customer?.bank_detail?.acc_holder}`
            : '',
          micrCode: customer?.bank_detail?.micr_code
            ? `${customer?.bank_detail?.micr_code}`
            : '',
          employeeNumber: customer?.indv_detail?.employeeNumber
            ? `${customer?.indv_detail?.employeeNumber}`
            : '',
          isThinCustomer: false,
        },

        businessOfInsured: viewProposalSF?.businessOfInsured
          ? `${viewProposalSF?.businessOfInsured}`
          : '',
        anyPrevClaimsExp:
          viewProposalSF?.prevClaimExpDtls === true
            ? true
            : false,
        prevClaimExpDesc: viewProposalSF?.prevClaimExpDtls
          ?.prevClaimExpDesc
          ? `${viewProposalSF?.prevClaimExpDtls?.prevClaimExpDesc}`
          : '',
        isKutchaConstruct:
          viewProposalSF?.isKutchaConstruct === true ? true : false,
        policyType: viewProposalSF?.policyType
          ? `${viewProposalSF?.policyType}`
          : '',
        quoteNumber: viewProposalSF?.quoteNumber
          ? `${viewProposalSF?.quoteNumber}`
          : '',

        tenure: viewProposalSF?.tenure?.value
          ? `${viewProposalSF?.tenure?.value}`
          : '',
        policyStartDate: viewProposalSF?.policyStartDate,

        riskLocations:
          viewProposalSF?.policyType?.toString()?.toLowerCase() ===
          'non floater'
            ? viewProposalSF?.riskLocations?.map((riskLoc) => {
                return {
                  quoteNumber: viewProposalSF?.quoteNumber,
                  riskLocationID: riskLoc?.riskLocationID,
                  occupancyCodeValue: {
                    code: riskLoc?.occupancyCodeValue?.code,
                    value: riskLoc?.occupancyCodeValue?.value,
                    occupancySection:
                      riskLoc?.occupancyCodeValue?.occupancySection,
                    occupancyRate:
                      riskLoc?.occupancyCodeValue?.occupancyRate,
                    riskCode: riskLoc?.occupancyCodeValue?.riskCode,
                    rateCode: riskLoc?.occupancyCodeValue?.rateCode,
                    riskGrade: riskLoc?.occupancyCodeValue?.riskGrade,
                    riskGradeDefinition:
                      riskLoc?.occupancyCodeValue
                        ?.riskGradeDefinition,
                    riskPreference:
                      riskLoc?.occupancyCodeValue?.riskPreference,
                    gicClass: riskLoc?.occupancyCodeValue?.gicClass,
                    stfiRate: riskLoc?.occupancyCodeValue?.stfiRate,
                    rsmdRate: riskLoc?.occupancyCodeValue?.rsmdRate,
                  },
                  riskLocAddress: {
                    addressLine1:
                      riskLoc?.riskLocAddress?.address_line1,
                    addressLine2:
                      riskLoc?.riskLocAddress?.address_line2,
                    addressLine3:
                      riskLoc?.riskLocAddress?.address_line3,
                    landmark: riskLoc?.riskLocAddress?.land_mark,
                    pinCode: riskLoc?.riskLocAddress?.pin_code.replace(
                      ' ',
                      '',
                    ),
                    state: riskLoc?.riskLocAddress?.state,
                    city: riskLoc?.riskLocAddress?.city,
                    district: riskLoc?.riskLocAddress?.district,
                    zone: riskLoc?.riskLocAddress?.zone,
                    eqZone: riskLoc?.riskLocAddress?.eqZone,
                    locationCode:
                      riskLoc?.riskLocAddress?.locationCode,
                    isSamePremises: false,
                    allIndiaBasisDesc:
                      riskLoc?.riskLocAddress?.allIndiaBasisDesc,
                  },

                  buildingSI: riskLoc?.buildingSI,
                  plantMachinerySI: riskLoc?.plantMachinerySI,
                  furnitureFixtureSI: riskLoc?.furnitureFixtureSI,
                  rawMaterialSI: riskLoc?.rawMaterialSI,
                  otherContentsSI: riskLoc?.otherContentsSI,
                  stocksSI: riskLoc?.stocksSI,
                  stocksInProcessSI: riskLoc?.stocksInProcessSI,

                  fireExtinguishApplisDtls: riskLoc?.fireExtinguishApplisDtls?.map(
                    (fire) => {
                      return {
                        applianceCode: fire?.value,
                        isSelected: fire?.selected,
                      };
                    },
                  ),
                  constructionClass: riskLoc?.constructionClass,
                  waterbodyDistance: riskLoc?.waterbodyDistance,
                  securityProvisions: riskLoc?.securityProvisions,
                  loadingPct: riskLoc?.loadingPct,
                  discountPct: riskLoc?.discountPct,
                  prevClaimExpDesc: riskLoc?.prevClaimExpDesc,

                  premium: {
                    locNetPremium:
                      riskLoc?.premium?.locationNetPremium,
                    locGST: riskLoc?.premium?.locationGST,
                    locTotalPremium:
                      riskLoc?.premium?.locationTotalPremium,
                    stampDuty: riskLoc?.premium?.stampDuty,
                  },
                };
              })
            : viewProposalSF?.policyType
                ?.toString()
                ?.toLowerCase() === 'floater'
            ? viewProposalSF?.riskLocations?.map((fireData) => {
                return {
                  quoteNumber: viewProposalSF?.quoteNumber,
                  riskLocationID: fireData?.riskLocationID,

                  occupancyCodeValue: {
                    code: fireData?.occupancyCodeValue?.code,
                    value: fireData?.occupancyCodeValue?.value,
                    occupancySection:
                      fireData?.occupancyCodeValue?.occupancySection,
                    occupancyRate:
                      fireData?.occupancyCodeValue?.occupancyRate,
                    riskCode: fireData?.occupancyCodeValue?.riskCode,
                    rateCode: fireData?.occupancyCodeValue?.rateCode,
                    riskGrade:
                      fireData?.occupancyCodeValue?.riskGrade,
                    riskGradeDefinition:
                      fireData?.occupancyCodeValue
                        ?.riskGradeDefinition,
                    riskPreference:
                      fireData?.occupancyCodeValue?.riskPreference,
                    gicClass: fireData?.occupancyCodeValue?.gicClass,
                    stfiRate: fireData?.occupancyCodeValue?.stfiRate,
                    rsmdRate: fireData?.occupancyCodeValue?.rsmdRate,
                  },
                  riskLocAddress: {
                    addressLine1: '',
                    addressLine2: '',
                    addressLine3: '',
                    landmark: '',
                    pinCode: '',
                    state: '',
                    city: '',
                    district: '',
                    zone: '',
                    eqZone: '',
                    locationCode: '',
                    isSamePremises: false,
                    allIndiaBasisDesc: '',
                  },
                  buildingSI: fireData?.buildingSI,
                  plantMachinerySI: fireData?.plantMachinerySI,
                  furnitureFixtureSI: fireData?.furnitureFixtureSI,
                  rawMaterialSI: fireData?.rawMaterialSI,
                  otherContentsSI: fireData?.otherContentsSI,
                  stocksSI: fireData?.stockSI,
                  stocksInProcessSI: fireData?.stocksInProcessSI,
                  stockOnFloaterBasis: fireData?.stockOnFloaterBasis,
                  floaterLocations: fireData?.floaterLocations.map(
                    (floatLoc) => {
                      return {
                        addressLine1: floatLoc?.address_line1,
                        pinCode: floatLoc?.pin_code.replace(' ', ''),
                        state: floatLoc?.state,
                        city: floatLoc?.city,
                        district: floatLoc?.district,
                        zone: floatLoc?.zone,
                        eqZone: floatLoc?.eqZone,
                        locationCode: floatLoc?.locationCode,
                      };
                    },
                  ),
                  maxStockSIAtOneLoc: fireData?.maxStockSIAtOneLoc,
                  fireExtinguishApplisDtls: fireData?.fireExtinguisherAppliancesDetails?.map(
                    (fire) => {
                      return {
                        applianceCode: fire?.value,
                        isSelected: fire?.selected,
                      };
                    },
                  ),
                  constructionClass: fireData?.constructionClass,
                  waterbodyDistance: fireData?.waterbodyDistance,
                  securityProvisions: fireData?.securityProvisions,

                  loadingPct: fireData?.loadingPct,
                  discountPct: fireData?.discountPct,
                  prevClaimExpDesc: fireData?.prevClaimExpDesc,

                  premium: {
                    locNetPremium:
                      fireData?.premium?.locationNetPremium,
                    locGST: fireData?.premium?.locationGST,
                    locTotalPremium:
                      fireData?.premium?.locationTotalPremium,
                    stampDuty: fireData?.premium?.stampDuty,
                  },
                };
              })
            : {},
        policyStartDate: viewProposalSF?.policyStartDate
          ? `${viewProposalSF?.policyStartDate}`
          : '',

        clauses: {
          default: viewProposalSF?.clauses?.default.map((data) => {
            return data;
          }),
          userDefined: viewProposalSF?.clauses?.userDefined.map(
            (data) => {
              return data;
            },
          ),
        },
        warranties: {
          default: viewProposalSF?.warranties?.default.map((data) => {
            return data;
          }),
          userDefined: viewProposalSF?.warranties?.userDefined.map(
            (data) => {
              return data;
            },
          ),
        },
        conditions: {
          default: viewProposalSF?.conditions?.default.map((data) => {
            return data;
          }),
          userDefined: viewProposalSF?.conditions?.userDefined.map(
            (data) => {
              return data;
            },
          ),
        },
        exclusions: {
          default: viewProposalSF?.exclusions?.default.map((data) => {
            return data;
          }),
          userDefined: viewProposalSF?.exclusions?.userDefined.map(
            (data) => {
              return data;
            },
          ),
        },

        finalisedPremium: {
          locNetPremium: viewProposalSF?.finalisedPremium
            ?.locNetPremium
            ? viewProposalSF?.finalisedPremium?.locNetPremium
            : 0,
          locGST: viewProposalSF?.finalisedPremium?.locGST
            ? viewProposalSF?.finalisedPremium?.locGST
            : 0,
          locTotalPremium: viewProposalSF?.finalisedPremium
            ?.locTotalPremium
            ? viewProposalSF?.finalisedPremium?.locTotalPremium
            : 0,
          stampDuty: viewProposalSF?.finalisedPremium?.stampDuty
            ? viewProposalSF?.finalisedPremium?.stampDuty
            : 0,
        },
        financierDtls: {
          financerName: viewProposalSF?.financierDtls?.financerName,
          financerAddress:
            viewProposalSF?.financierDtls?.financerAddress,
          financerAgreementType:
            viewProposalSF?.financierDtls?.financerAgreementType,
          loanAccountNumber:
            viewProposalSF?.financierDtls?.loanAccountNumber,
          FileNumber: viewProposalSF?.financierDtls?.fileNumber,
        },

        uploadDocuments:
          viewProposalSF?.uploadedDocuments &&
          viewProposalSF?.uploadedDocuments?.length > 0
            ? viewProposalSF?.uploadedDocuments?.map((uploadDet) => {
                return {
                  documentType: {
                    code: uploadDet?.documentType?.code,
                    value: uploadDet?.documentType?.value,
                  },
                  documentName: uploadDet?.documentName,
                  documentSize: uploadDet?.documentSize,
                  base64EncodedDoc: uploadDet?.base64EncodedDoc,
                };
              })
            : [],
      },
    };
  };

  let policySummaryData = [
    {
      grid_data: [
        {
          colSpan: repeat,
          text: product_info,
        },
      ],
    },
    {
      grid_data: [
        {
          colSpan: repeat,
          label: (
            <div>
              {customer?.cust_type?.value === 'Organisation'
                ? 'Organization Name'
                : 'Customer Name'}
            </div>
          ),
          text: (
            <div className="mt-1">
              {customer?.cust_type?.value === 'Organisation'
                ? reformData(customer?.org_detail?.org_name, null)
                : reformData(customer?.indv_detail?.full_name, null)}
            </div>
          ),
        },
        {
          label: 'Proposal Number',
          text: reformData(viewProposalSF?.proposalNumber, null),
        },
        {
          label: 'Policy Number',
          text: reformData(policy_no, null),
        },
      ],
    },
    {
      grid_data: [
        {
          label: 'Policy Start Date',
          text: (
            <div className="mt-1">
              {reformData(viewProposalSF?.startDate, null)}
            </div>
          ),
        },
        {
          label: 'Policy End Date',
          text: (
            <div className="mt-1">
              {reformData(viewProposalSF?.endDate, null)}
            </div>
          ),
        },
      ],
    },
    {
      grid_data: [
        {
          text: (
            <>
              <div className="flex flex-col">
                <Text severity="info" type="normal">
                  Annual Premium
                </Text>
                <Text severity="info">(inclusive of taxes)</Text>
              </div>
            </>
          ),
        },
        {
          text: (
            <div className="flex flex-col">
              <Text severity="info" type="larger">
                {CurrencyFormater(
                  reformData(
                    viewProposalSF?.finalisedPremium?.locTotalPremium,
                    null,
                  ),
                  true,
                  false,
                  branding,
                  true,
                )}
              </Text>
              <div>
                <Text
                  severity="action"
                  type="label"
                  className="quanta_link cursor-pointer mt-1"
                  onClick={(_) => {
                    setShowViewBreakup(true);
                  }}
                >
                  View Breakup
                </Text>
              </div>
            </div>
          ),
        },
        {
          colSpan: repeat,
          text: (
            <Button
              size="medium"
              className="mt-4 w-full max-h-10"
              flat={true}
              disabled={loadingDownload}
              iconPre={
                <FontAwesomeIcon icon={faEnvelope} className="ml-4" />
              }
              onClick={(e) => setShowEmail(true)}
            >
              Email Policy Schedule
            </Button>
          ),
        },
        {
          colSpan: repeat,
          text: (
            <Button
              size="medium"
              className="mt-4 w-full max-h-10"
              flat={true}
              disabled={loadingDownload}
              iconPre={
                <FontAwesomeIcon icon={faSms} className="ml-4" />
              }
              onClick={(e) => setShowSms(true)}
            >
              Message Policy Schedule
            </Button>
          ),
        },
        {
          colSpan: repeat,
          text: (
            <Button
              size="medium"
              className="mt-4 w-full max-h-10"
              flat={true}
              disabled={loadingDownload}
              iconPre={
                <FontAwesomeIcon
                  icon={loadingDownload ? faSpinner : faDownload}
                  className="ml-4"
                  spin={loadingDownload}
                />
              }
              onClick={async (_) => {
                try {
                  setLoadingDownload(true);
                  let policyPDFBase64String = mutateQuery({
                    mutation: DOWNLOAD_POLICY_PDF,
                    variables: sendPdfData(
                      viewProposalSF,
                      customer,
                      policy_no,
                    ),
                  });
                  let {
                    data: dataBase64String,
                  } = await policyPDFBase64String;
                  const { sendPolicyPDF } = dataBase64String;
                  const {
                    base64Pdf: downloadBase64String,
                  } = sendPolicyPDF;
                  setLoadingDownload(false);
                  let byteCharacters = atob(
                    downloadBase64String.toString(),
                  );
                  let byteNumbers = new Array(byteCharacters.length);
                  for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                  }
                  let byteArray = new Uint8Array(byteNumbers);
                  let file = new Blob([byteArray], {
                    type: 'application/pdf;base64',
                  });
                  let fileURL = URL.createObjectURL(file);
                  // window.open(fileURL);
                  const downloadLink = document.createElement('a');
                  const fileName = `Policy-${policy_no}.pdf`;
                  downloadLink.href = fileURL;
                  downloadLink.download = fileName;
                  downloadLink.click();
                  window.URL.revokeObjectURL(fileURL);
                } catch (error) {
                  setAlerts([
                    {
                      id: Date.now(),
                      content: (
                        <div className="flex flex-col w-full h-full">
                          <Text type="normal">{error.message}</Text>
                        </div>
                      ),
                      type: 'error',
                      timeout: null,
                      disableClose: false,
                    },
                  ]);
                  setLoadingDownload(false);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              }}
            >
              {loadingDownload
                ? 'Downloading...'
                : 'Download Policy Schedule'}
            </Button>
          ),
        },
        // {
        //   colSpan: 2,
        //   text: (
        //     <Button
        //       size="medium"
        //       className="mt-2 w-full max-h-10"
        //       flat={true}
        //       iconPre={
        //         <FontAwesomeIcon icon={faUpload} className="ml-4" />
        //       }
        //       onClick={() => {
        //         if (
        //           sessionStorage
        //             ?.getItem('intermediaryCode')
        //             ?.toString()
        //             ?.toLowerCase() !==
        //           viewProposalSF?.intermediaryDetails?.code
        //             ?.toString()
        //             ?.toLowerCase()
        //         ) {
        //           sessionStorage?.setItem('fieldUserCode', '');
        //           sessionStorage?.setItem('fieldUserName', '');
        //         }
        //         sessionStorage?.setItem(
        //           'intermediaryCode',
        //           viewProposalSF?.intermediaryDetails?.code,
        //         );
        //         sessionStorage?.setItem(
        //           'intermediaryName',
        //           myIntermediaries?.find(
        //             (imd) =>
        //               imd?.intermediaryCode
        //                 ?.toString()
        //                 ?.toLowerCase() ===
        //               viewProposalSF?.intermediaryDetails?.code
        //                 ?.toString()
        //                 ?.toLowerCase(),
        //           )?.intermediaryName,
        //         );
        //         sessionStorage?.setItem(
        //           'branchOfficeCode',
        //           myIntermediaries?.find(
        //             (imd) =>
        //               imd?.intermediaryCode
        //                 ?.toString()
        //                 ?.toLowerCase() ===
        //               viewProposalSF?.intermediaryDetails?.code
        //                 ?.toString()
        //                 ?.toLowerCase(),
        //           )?.businessLocations &&
        //             myIntermediaries?.find(
        //               (imd) =>
        //                 imd?.intermediaryCode
        //                   ?.toString()
        //                   ?.toLowerCase() ===
        //                 viewProposalSF?.intermediaryDetails?.code
        //                   ?.toString()
        //                   ?.toLowerCase(),
        //             )?.businessLocations?.length > 0
        //             ? myIntermediaries?.find(
        //                 (imd) =>
        //                   imd?.intermediaryCode
        //                     ?.toString()
        //                     ?.toLowerCase() ===
        //                   viewProposalSF?.intermediaryDetails?.code
        //                     ?.toString()
        //                     ?.toLowerCase(),
        //               )?.businessLocations[0]?.code
        //             : '',
        //         );
        //         sessionStorage?.setItem(
        //           'branchOfficeName',
        //           myIntermediaries?.find(
        //             (imd) =>
        //               imd?.intermediaryCode
        //                 ?.toString()
        //                 ?.toLowerCase() ===
        //               viewProposalSF?.intermediaryDetails?.code
        //                 ?.toString()
        //                 ?.toLowerCase(),
        //           )?.businessLocations &&
        //             myIntermediaries?.find(
        //               (imd) =>
        //                 imd?.intermediaryCode
        //                   ?.toString()
        //                   ?.toLowerCase() ===
        //                 viewProposalSF?.intermediaryDetails?.code
        //                   ?.toString()
        //                   ?.toLowerCase(),
        //             )?.businessLocations?.length > 0
        //             ? myIntermediaries?.find(
        //                 (imd) =>
        //                   imd?.intermediaryCode
        //                     ?.toString()
        //                     ?.toLowerCase() ===
        //                   viewProposalSF?.intermediaryDetails?.code
        //                     ?.toString()
        //                     ?.toLowerCase(),
        //               )?.businessLocations[0]?.name
        //             : '',
        //         );
        //         window?.scrollTo({ top: 0, behavior: 'smooth' });
        //         history.push(`/upload-documents/policy/${policy_no}`);
        //       }}
        //     >
        //       Upload Policy Documents
        //     </Button>
        //   ),
        // },
        // {
        //   colSpan: 2,
        //   text: (
        //     <TransactionComponent>
        //       <Button
        //         size="medium"
        //         className="mt-2 w-full max-h-10"
        //         flat={true}
        //         iconPre={
        //           <FontAwesomeIcon icon={faUpload} className="ml-4" />
        //         }
        //         onClick={() => {
        //           window?.scrollTo({ top: 0, behavior: 'smooth' });
        //           history.push(
        //             `/policy/endorse/${customer_id}/${viewProposalSF?.product?.productCode}/${viewProposalSF?.product?.productName}/${proposal_no}`,
        //           );
        //         }}
        //       >
        //         Endorse Policy
        //       </Button>
        //     </TransactionComponent>
        //   ),
        // },
      ].filter((b) => b),
    },
  ];

  return (
    <>
      <DataGridGroup
        data={policySummaryData}
        repeat={repeat}
        textType="normal"
        titleType="label"
      />
      <ModalViewBreakupFire
        {...{
          showViewBreakup,
          setShowViewBreakup,
          productName:viewProposalSF?.product?.productName,
          productCode: '1132',
          lobCode: '11',
          lobName: 'Fire',
          workmenCompensationQuote: viewProposalSF,
          locationPremium: {
            locationNetPremium:
              viewProposalSF?.finalisedPremium?.locNetPremium,
            locationGST: viewProposalSF?.finalisedPremium?.locGST,
            locationTotalPremium:
              viewProposalSF?.finalisedPremium?.locTotalPremium,
            stampDuty: viewProposalSF?.finalisedPremium?.stampDuty,
          },
          premiumBreakupFor: 'Policy',
        }}
      />
      <ModalSendEmail
        {...{
          showEmail,
          setShowEmail,
          initialEmail: customer?.contact?.email,
          SEND_EMAIL_QUERY: SEND_POLICY_EMAIL_ALERT,
          getPayLoad: (email, ccEmailIds) => {
            return {
              ...getPayLoademail(
                email,
                ccEmailIds),
              email,
              ccEmailIds,
            };
          },
        }}
      />
      <ModalSendSms
        {...{
          showSms,
          setShowSms,
          initialMobile: customer?.contact?.mobile,
          SEND_SMS_QUERY: SEND_POLICY_SMS_ALERT,
          getPayLoad: (
            mobile,
            alternateMobileNos,
            whatsappNo,
            modes,
          ) => {
            return {
              ...getPayLoadsms(
                mobile,
                alternateMobileNos,
              ),
              mobile,
              alternateMobileNos,
              whatsappNo,
              modes,
            };
          },
        }}
      />
    </>
  );
}
